import React, { useRef } from 'react';
import { Typography } from '@mui/material';
import {
  configValueLabels,
  TaskType,
  cronJobLabels,
  CronJobStatus,
} from 'src/api/hooks/useConfigs.types';
import { FacebookTokenControl } from 'src/components/FacebookToken/FacebookTokenControl';
import { CronJobSwitchCellProps } from 'src/components/Cron/CronJobSwitchCell.types';
import { CronJobSwitch } from 'src/components/Cron';

export const CronJobSwitchCell: React.FC<CronJobSwitchCellProps> = ({
  row,
  expiresAt,
  shouldRenew,
  onConfigEdit,
  onFbSuccess,
  renewAccessTokenLoading,
}) => {
  const { id, name, value } = row;
  const fbLoginRef = useRef<HTMLButtonElement>(null);
  const isTokenFetch = name === configValueLabels[TaskType.DellaFacebookAccessToken];
  const isCronStatus =
    Object.values(cronJobLabels).includes(name) || Object.values(configValueLabels).includes(name);

  if (!isCronStatus) {
    return <Typography>-</Typography>;
  }

  const isActivated = value === CronJobStatus.ENABLED;

  const handleToggle = () => {
    if (isTokenFetch) {
      fbLoginRef.current?.click();
    } else {
      onConfigEdit({
        id,
        name,
        value: isActivated ? CronJobStatus.DISABLED : CronJobStatus.ENABLED,
      });
    }
  };

  if (isTokenFetch) {
    return (
      <FacebookTokenControl
        expiresAt={expiresAt}
        shouldRenew={shouldRenew}
        onToggle={handleToggle}
        onFbSuccess={onFbSuccess}
        fbLoginRef={fbLoginRef}
        renewAccessTokenLoading={renewAccessTokenLoading}
      />
    );
  } else {
    return <CronJobSwitch isActivated={isActivated} onToggle={handleToggle} />;
  }
};
